export default __webpack_public_path__ + "static/media/RU.f6bf75dc.svg";